import React, { useState } from "react";
import { listStyles } from "./style.js";

const Row = ({ index, entry, entryStyle, rowHeight }) => {
  const [_value, changeValue] = useState(entry.value);

  const handleInput = (e) => {
    changeValue(e.target.value);
  };

  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };

  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };

  return (
    <div
      key={index}
      style={{
        ...listStyles.entry,
        height: rowHeight,
        ...entryStyle,
      }}
      onClick={entry.func}
      onContextMenu={entry.contextFunc}
      onMouseOver={highlight}
      onMouseOut={unhighlight}
    >
      {entry.valueOnChange ? (
        <input
          key={index}
          style={listStyles.input}
          type={"text"}
          value={_value}
          autoFocus
          onFocus={(e) => {
            e.target.select();
          }}
          spellCheck={false}
          onChange={handleInput}
          onKeyDown={(e) => {
            if (e.key === "Enter") entry.enterFunc(_value);
            else if (e.key === "Escape") {
              entry.cancelFunc();
              changeValue(entry.value);
            }
          }}
        />
      ) : (
        entry.content
      )}
    </div>
  );
};

class EntryList extends React.Component {
  render() {
    const rows = this.props.entries.map((entry, index) => (
      <Row
        key={index}
        entry={entry}
        rowHeight={this.props.rowHeight}
        entryStyle={this.props.entryStyle}
        index={index}
      />
    ));
    return (
      <div
        style={{
          ...listStyles.container,
          ...this.props.containerStyle,
        }}
      >
        {rows}
      </div>
    );
  }
}

export default EntryList;
